import React, { useEffect, useMemo } from 'react';
import styles from './index.module.scss';
import icon_subtract from 'asset/image/icon_subtract.svg';

import { Button, Modal } from 'antd';
import { AllMeetingStatus, IScheduleList } from 'type/meeting';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { RedirectPage } from 'util/meeting';
import { queryStringify } from 'util/format';

interface IProps {
  show: boolean;
  modalTop?: number;
  modalLeft?: number;
  onCancel?: () => void;
  scheduleDetail?: IScheduleList;
}

const MeetingDetailDialog: React.FC<IProps> = ({ show, modalTop, modalLeft, onCancel, scheduleDetail }) => {
  const showModalStyle = !!modalTop && !!modalLeft;
  const history = useHistory();
  const modalStyle = showModalStyle ? { left: modalLeft, top: modalTop, margin: 0 } : {};

  const handleCancel = () => {
    onCancel && onCancel();
  };

  const redirect = (path: string, query?: string) => {
    history.push(`${path}${query || ''}`);
  };

  const gotoDetail = () => {
    redirect(`/details/${scheduleDetail?.meetingNo}`, queryStringify({ from: 'schedule' }));
  };

  const meetingTime = useMemo(() => {
    if (!scheduleDetail?.beginTime || !scheduleDetail?.endTime) return '';
    const begin = moment(Number(scheduleDetail?.beginTime));
    const end = moment(Number(scheduleDetail?.endTime));
    if (begin.isSame(end, 'day')) {
      return `${begin.format('MM月DD日')} ${begin.format('HH:mm')}-${end.format('HH:mm')}`;
    } else {
      return `${begin.format('MM月DD日')} ${begin.format('HH:mm')}-${end.format('MM月DD日')} ${end.format('HH:mm')}`;
    }
  }, [show, scheduleDetail?.beginTime, scheduleDetail?.endTime]);

  return (
    <>
      <Modal
        className={styles.modal}
        style={modalStyle}
        footer={null}
        maskStyle={{ backgroundColor: 'transparent' }}
        visible={show}
        width={300}
        onCancel={handleCancel}
        closable={false}
        destroyOnClose
      >
        <div className={styles.subject}>{scheduleDetail?.subject}</div>
        {scheduleDetail?.meetingStatus == AllMeetingStatus.AUDITING && (
          <div className={styles.meeting_status}>
            <img src={icon_subtract} className={styles.icon} />
            <div>审批中</div>
          </div>
        )}
        <div className={styles.meeting_info}>
          <div className={styles.meeting_info_title}>预约人</div>
          <div className={styles.meeting_info_content}>{scheduleDetail?.organizerName}</div>
        </div>
        <div className={styles.meeting_info}>
          <div className={styles.meeting_info_title}>时间</div>
          <div className={styles.meeting_info_content}>{meetingTime}</div>
        </div>
        <div className={styles.meeting_info}>
          <div className={styles.meeting_info_title}>地址</div>
          <div className={styles.meeting_info_content}>{scheduleDetail?.address}</div>
        </div>

        <div className={styles.meeting_go_detail} onClick={gotoDetail}>
          <Button size="small" className={styles.meeting_go_detail_button} type="primary">
            查看详情
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default MeetingDetailDialog;
